import { SYM_METHOD, SYM_ELEMENT_REF } from "./enum/Symbol";
import useWeakMap from "./utils/useWeakMap";


/**@type {fnUseSymbolProp} */
const useSymbolProp = (() => {

    const caching = useWeakMap();

    const initInstance = (props) => {

        const getValue = (symbol, defaultValue) => {
            if (typeof symbol !== 'symbol') {
                console.error("[getSpecial] Key must be a Symbol");
            }
            return props[symbol] || defaultValue;
        }

        const setValue = (symbol, value) => {
            if (typeof symbol !== 'symbol') {
                console.error("[setSpecial] Key must be a Symbol");
            }
            props[symbol] = value;
        }

        const removeProp = () => {
            caching.delete(props);
        }

        const copyTo = (symbol, obj) => {
            obj[symbol] = props[symbol];
        }

        return {
            getValue,
            setValue,
            removeProp,
            copyTo
        }
    }

    return (props) => {
        if (!caching.has(props)) {
            caching.set(props, initInstance(props));
        }
        return caching.get(props);
    }
})()

export default useSymbolProp;